/**
 * Sticky scroll-to-top button. Shows after scrolling down, smooth scrolls to top on click.
 */
class ScrollToTop extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.scroll-to-top__button');
    this.showAfter = 400;
    this.boundScroll = this.onScroll.bind(this);

    if (this.button) {
      this.button.addEventListener('click', () => this.scrollToTop());
      window.addEventListener('scroll', this.boundScroll, { passive: true });
      // Initial check in case page is loaded scrolled
      this.onScroll();
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.boundScroll);
  }

  onScroll() {
    if (window.scrollY > this.showAfter) {
      this.classList.add('is-visible');
    } else {
      this.classList.remove('is-visible');
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

customElements.define('scroll-to-top', ScrollToTop);
